module.exports = __webpack_public_path__ + "static/media/naslovnicaBJN2.3ee44bff.png";